import React, { useState } from "react";
import axios from "axios";
import { formattedDate } from "./utils";
import Forecast from "./Forecast";

export default function Weather(props) {
  const [weatherData, setWeatherData] = useState({ ready: false });
  const [city, setCity] = useState(props.defaultCity);

  function handleResponse(response) {
    setWeatherData({
      ready: true,
      coordinates: response.data.coordinates,
      temperature: response.data.temperature.current,
      humidity: response.data.temperature.humidity,
      date: new Date(response.data.time * 1000),
      description: response.data.condition.description,
      icon: `http://shecodes-assets.s3.amazonaws.com/api/weather/icons/${response.data.condition.icon}.png`,
      wind: response.data.wind.speed,
      city: response.data.city,
    });
  }

  function handleSubmit(event) {
    event.preventDefault();
    search();
  }

  function handleCityChange(event) {
    setCity(event.target.value);
  }

  function search() {
    const apiKey = "5b5d4cfo1f7a10abe66f9356cctb6a8c";
    let apiUrl = `https://api.shecodes.io/weather/v1/current?query=${city}&key=${apiKey}&units=metric`;

    axios.get(apiUrl).then(handleResponse);
  }

  if (weatherData.ready) {
    return (
      <div className="weather">
        <form onSubmit={handleSubmit}>
          <input
            className="form-input"
            type="search"
            placeholder="Enter a city..."
            onChange={handleCityChange}
          />
          <button className="form-button" type="submit">
            Search
          </button>
        </form>

        <div>
          <ul className="weather-basicInfo">
            {weatherData.ready && <li className="weather-city">{city}</li>}
            <li className="weather-dateTime">
              {formattedDate(weatherData.date)}
            </li>
            <li className="weather-description">{weatherData.description}</li>
          </ul>
          <div className="weather-detailInfo">
            <div className="weather-temperatureInfo">
              <div className="weather-icon">
                <img src={weatherData.icon} alt={weatherData.description} />
              </div>
              <div className="weather-temperature">
                {Math.round(weatherData.temperature)}
                <span className="weather-unit">°C</span>
              </div>
            </div>
            <div>
              <ul className="weather-otherInfo">
                <li className="weather-humidity">
                  Humidity: {weatherData.humidity}%
                </li>
                <li className="weather-wind">Wind: {weatherData.wind}km/h</li>
              </ul>
            </div>
          </div>
        </div>
        <Forecast coordinates={weatherData.coordinates} />
      </div>
    );
  } else {
    search();
    return "Loading...";
  }
}
